<script>
import $ from "jquery"
import {ref, watch} from "vue";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import LoadingPic from "@/components/assetComponents/LoadingPic.vue";
import {useStore} from "vuex";
import {Device} from "@capacitor/device";

export default {
  name: "WalletPage",
  components: {LoadingPage , LoadingPic},
  setup() {

    let store = useStore()
    let loading = ref(false)
    let loading_pic = ref(false)

    let info_bank = ref({
      bank_shaba: store.state.info.bank_shaba,
      bank_id: store.state.info.bank_id
    })

    let page = ref('inventory')
    let dialog = ref(false)
    let details_card = ref (false)

    let history = ref([])
    let cards = ref(store.state.Cards)
    let wallet = ref(0)

    let select_card = ref(null)

    let add_card = ref({
      name: '',
      bankname: '',
      shaba: '',
      account: '',
      card: '',
    })

    let inc_wallet = ref({
      price: null,
      action: null,
      pic: null,
    })

    let show_pic = ref(null)

    watch(()=>inc_wallet.value.action , ()=>{
      open_input()
    })

    function my_wallet() {

      loading.value = true
      FreeWorld.Heisenberg({action:'wallets'} , 'info' , true).then((res)=>{

        loading.value = false
        history.value = res.data.wallets
        wallet.value = res.data.wallet

      }).catch((res)=>{
        loading.value = false
        Swals.Catch(res , my_wallet)
      })

    }
    my_wallet()

    function open_input() {
      let div = document.getElementById('bank')
      let icon = $("#icon")
      if (inc_wallet.value.action === 'receipt'){
        div.style.height = '37rem'
        icon.removeClass('min_rotate_icon').addClass('rotate_icon')
      }else {
        div.style.height = '4rem'
        icon.removeClass('rotate_icon').addClass('min_rotate_icon')
      }
    }

    function open_dialog(action , type , item) {

      if (type){
        details_card.value = true
        add_card.value = {
          name: item.name,
          bankname: item.bankname,
          shaba: item.shaba,
          account: item.account,
          card: item.card,
        }
      }

      if (action){

        $("#dialog").removeClass('animate__fadeOut').addClass('animate__fadeIn')
        dialog.value = !dialog.value

      }else {

        $("#dialog").removeClass('animate__fadeIn').addClass('animate__fadeOut')
      setTimeout(()=>{
        add_card.value = {
          name: '',
          bankname: '',
          shaba: '',
          account: '',
          card: '',
        }
      dialog.value = !dialog.value
        details_card.value = false
      },700)

      }

    }

    function add_cards() {

      if (add_card.value.name.trim().length === 0){Swals.Fault('لطفا نام صاحب کارت را وارد کنید!');return false}
      if (add_card.value.bankname.trim().length === 0){Swals.Fault('لطفا نام بانک را وارد کنید!');return false}
      if (add_card.value.shaba.length === 0){Swals.Fault('لطفا شماره شبا را وارد کنید!');return false}
      if (add_card.value.account.length === 0){Swals.Fault('لطفا شماره حساب را وارد کنید!');return false}
      if (add_card.value.card.length === 0){Swals.Fault('لطفا شماره کارت را وارد کنید!');return false}

      loading.value = true
      FreeWorld.Heisenberg(add_card.value , 'add_card' , true).then((res)=>{

        loading.value = false
        if (res.data.status === 'ok'){
          store.commit('set_Card' , res.data.cards)
          cards.value = store.state.Cards
          Swals.Done('شماره کارت شما با موفقیت ثبت شد')
          open_dialog(false)
        }else {
          Swals.Fault('متاسفانه شماره کارت شما ثبت نشد!')
        }

      }).catch((res)=>{
        loading.value = false
        Swals.Catch(res , add_cards)
      })

    }

    function delete_cart(item) {

      Swals.Question('آیا میخواهید این کارت را حذف کنید؟' , 'حذف کارت').then((res)=>{
        if (res.isConfirmed){

          loading.value = true
          FreeWorld.Heisenberg({action:'card_delete ',card_id:item.id} , 'info').then((res)=>{

            loading.value = false
            if (res.data.status === 'ok'){
              Swals.Done('کارت مورد نظر شما با موفقیت حذف شد')

              $("#Card" + item.id).removeClass('animate__fadeInDown').addClass('animate__backOutDown')
              setTimeout(()=>{
                store.commit('delete_Card' , item)
                // cards.value = store.state.Cards
              },500)

            }else {
              loading.value = false
              Swals.Fault('متاسفانه کارت مورد نظر شما حذف نشد!')
            }

          }).catch((res)=>{
            Swals.Catch(res , delete_cart)
          })

        }
      })

    }

    function upload_pic(e) {

      const file = e.target.files[0];
      if (file !== undefined) {

        loading_pic.value = true

        FreeWorld.GoodMan(file).then((res)=>{

                loading_pic.value = false
              if (res.data.status === 'ok') {
                show_pic.value = URL.createObjectURL(file);
                inc_wallet.value.pic = res.data.name
              }else {
                Swals.Fault('لطفا از فرمت عکس مورد نظر اطمینان حاصل فرمایید!')
              }

        }).catch((res) => {
          loading_pic.value = false
          Swals.Catch(res , ()=>{upload_pic(e)})
        })
      }


    }

    function Settlement_request() {
      if (wallet.value === 0){Swals.Fault('کیف پول شما خالی است!');return false}
      if (cards.value.length === 0){Swals.Fault('جهت تسویه اول اطلاعات کارت بانکی خود را وارد کنید');return false}
      if (select_card.value === null){Swals.Fault('لطفا یکی از کارت های خود را جهت تسویه انتخاب کنید');return false}

      loading.value = true
      FreeWorld.Heisenberg({card_id:select_card.value},'add_checkout' , true).then((res)=>{

        loading.value = false
        if (res.data.status === 'ok'){
          Swals.Done('درخواست تسویه شما با موفقیت ثبت شد')
          select_card.value = null
        }else {
          Swals.Fault('متاسفانه درخواست تسویه شما ثبت نشد!')
          select_card.value = null
        }

      }).catch((res)=>{
        loading.value = false
        Swals.Catch(res , Settlement_request)
      })

    }

   async function charge_wallet() {
      if (inc_wallet.value.price !== null && inc_wallet.value.price.length === 0) inc_wallet.value.price = null
      if (inc_wallet.value.price === null ){Swals.Fault('لطفا مبلغ مورد نظر خود را جهت شارژ کیف پول وارد کنید');return false}
      if (inc_wallet.value.price < 999 ){Swals.Fault('حداقل مبلغ شارژ کیف پول 1,000 تومان می باشد');return false}
      if (inc_wallet.value.action === null ){Swals.Fault('لطفا یکی از مراحل افزایش کیف پول را انتخاب کنید');return false}
      if (inc_wallet.value.action === 'receipt' && inc_wallet.value.pic === null ){Swals.Fault('لطفا عکس فیش واریزی را آپلود کنید');return false}


      if (inc_wallet.value.action === 'bank'){
        inc_wallet.value.pic = null

        await Device.getInfo().then(info => {
          inc_wallet.value.device = info.platform
        });

        let uid = FreeWorld.PinkMan(localStorage.getItem('uid') , 'de')
        window.location.href = 'https://market-app.ir/bank?action=send&mode=wallet&oid=0&uid=' + uid + '&price=' + inc_wallet.value.price + '&device=' + inc_wallet.value.device
        inc_wallet.value.price = null
        return false
      }

      loading.value = true
      FreeWorld.Heisenberg(inc_wallet.value , 'add_wallet' , true).then((res)=>{

        loading.value = false
        if (res.data.status === 'ok'){
          Swals.Done('افزایش کیف پول شما ثبت و پس از برسی به کیف پول شما اضافه میشود')
          inc_wallet.value = {
            price: null,
            action: null,
            pic: null,
          }
          show_pic.value = null
        }

      }).catch((res)=>{
        loading.value = false
        Swals.Catch(res , charge_wallet)
      })

    }

    return {

      open_input,
      page,
      history,
      loading,
      cards,
      dialog,
      open_dialog,
      add_card,
      add_cards,
      select_card,
      Settlement_request,
      delete_cart,
      details_card,
      charge_wallet,
      inc_wallet,
      upload_pic,
      show_pic,
      loading_pic,
      wallet,
      info_bank,

    }
  }
}
</script>


<template>

  <LoadingPage v-if="loading"></LoadingPage>
  <div v-if="dialog" @click="open_dialog(false)" class="bg_dialog"></div>

  <div id="main" :class="loading ? 'activeClass':'' " class="bg-main">

    <div class="div-top-arrow shadow-custom bg-white">
      <div class="d-flex justify-content-between align-items-center">
        <p class="font-color font-4 font-bold">کیف پول و پرداخت ها</p>
        <img onclick="window.history.back()" class="svg-arrow" src="../assets/img/arrow.svg" alt="">
      </div>
    </div>
    <br>
    <br>
    <br>

    <div class="p-body my-3">

      <div class="bg-white shadow-custom rounded-4 overflow-hidden">

        <div class="d-flex justify-content-around mb-5 overflow-hidden">

          <div @click="page = 'inventory'" :class="page === 'inventory' ? 'shadow_select rounded-top-4':'' " class="d-flex justify-content-center align-items-center flex-column w-50">
            <div class="d-flex mt-2">
              <img v-if="page === 'inventory' " class="icon_shadow" src="../assets/img/walletm1.png" style="width: 3rem;height: 3rem">
              <img v-else class="icon_shadow" src="../assets/img/wallet_active.svg" style="width: 2.5rem;height: 2.5rem">
            </div>
            <p :class="page === 'inventory' ? 'font-color font-4':'font-color_light font-5' " class="">موجودی </p>
          </div>

          <div @click="page = 'Transactions'" :class="page === 'Transactions' ? 'shadow_select rounded-top-4':'' " class="d-flex justify-content-center align-items-center flex-column w-50 py-1">
            <div class="d-flex mt-2">
              <img v-if="page === 'Transactions' " class="icon_shadow" src="../assets/img/list_active.svg" style="width: 3rem;height: 3rem">
              <img v-else class="icon_shadow" src="../assets/img/list_not_avtive.svg" style="width: 2.5rem;height: 2.5rem">
            </div>
            <p :class="page === 'Transactions' ? 'font-color font-4':'font-color_light font-4' " class="">تراکنش ها</p>
          </div>

        </div>



        <div v-if="page === 'inventory' " class="p-3">

          <p class="mb-3 font-4 font-color font-bold">موجودی کیف پول</p>

          <div class="shadow-custom font-bold bg-color-blue-light d-flex justify-content-center align-items-center p-3 rounded-3 mb-3">
            <p class="font-4 ms-1 font-color-green fw-bold">{{ wallet.toLocaleString() }}</p>
            <p class="font-5 font-color-green">تومان</p>
          </div>

          <div class="py-3 p-body bg-color-blue-light rounded-4 shadow-custom">

            <div class="d-flex align-items-center justify-content-between mb-3">
              <p class="font-4 font-bold">کارت های من</p>

              <div @click="open_dialog(true)" class="text-decoration-none d-flex align-items-center">
                <img src="../assets/img/add_color.svg" alt="" class="icon_shadow icon-size-2 ml-2">
                <p class="font-5 font-color">افزودن کارت</p>
              </div>
            </div>

            <div class="list_address mb-2">

              <div v-for="item in cards" :key="item.id" :class="select_card === item.id ? 'bg-color text-white':'bg-white font-color' " :id="'Card' + item.id" class="animate__animated animate__fadeInDown shadow-custom rounded-3 p-2 d-flex justify-content-between align-items-center my-3">
                <div @click="select_card = item.id" class="d-flex justify-content-between align-items-center w-75">
                  <img v-if="select_card === item.id" class="icon_shadow icon-size-2" src="../assets/img/credit.png">
                  <img v-else src="../assets/img/credit.svg" class="icon_shadow icon-size-2">

                  <div class="overflow-hidden mx-1 w-40">
                  <p class="mx-1 font-5 d-flex align-items-center" :class="{'txtoverflow':item.name.length > 10}">{{ item.name }}</p>
                  </div>

                  <div class="overflow-hidden mx-1 w-40">
                  <p class="font-5 d-flex align-items-center" :class="{'txtoverflow':item.bankname.length > 10}">{{ item.bankname }}</p>
                  </div>
                </div>
                <div class="d-flex justify-content-between align-items-center w-20">
                  <img @click="open_dialog(true , 'show' , item)" src="../assets/img/backk.png" class="icon_shadow icon-size-2">
                  <img @click="delete_cart(item)" class="icon_shadow icon-size-2" src="../assets/img/delet.png">
                </div>
              </div>

            </div>

            <div class="d-flex justify-content-center">
              <v-btn @click="Settlement_request" class="h-100 bg-red text-white font-4 border-0 rounded-3 p-2 w-60">تقاضای تسویه</v-btn>
            </div>

          </div>

          <p class="mt-5 mb-3 font-4 font-color font-bold">شارژ کیف پول</p>

          <input type="tel" onkeydown="return event.key !== ' '" class="shadow-custom bg-color-blue-light d-flex justify-content-center align-items-center p-3 rounded-3  text-center w-100 border-0 font-4" placeholder="مبلغ مورد نظر" v-model="inc_wallet.price">

          <div class="mt-3 shadow-custom bg-white d-flex justify-content-start align-items-center p-3 rounded-3 mb-2">
            <input v-model="inc_wallet.action" id="pay" name="wallet" value="bank" class="" type="radio">
            <label for="pay" class="mr-2 font-5 w-95">افزایش کیف پول توسط درگاه پرداخت</label>
          </div>

          <div id="bank" class="bank mt-3 shadow-custom bg-white p-3 rounded-3 ">

            <div class="d-flex justify-content-between align-items-center mb-4">
              <div class="d-flex justify-content-start align-items-center w-95">
                <input v-model="inc_wallet.action" id="fish" name="wallet" value="receipt" class="" type="radio">
                <label for="fish" class="mr-2 font-5 w-100">افزایش کیف پول توسط فیش بانکی</label>
              </div>
              <img id="icon" src="../assets/img/bottomarrow.png" style="width: 15px;height: 10px">
            </div>

            <div class="d-flex justify-content-start align-items-center mb-3">
              <img src="../assets/img/lightinfo.svg" class="icon-size-2">
              <p class="mr-2 font-5">لطفا هزینه را با شماره واریزی درج شده در کادر پایین واریز کرده و عکس فیش را
                آپلود کنید</p>
            </div>

            <p class="font-5 text-center">(پس از تایید اپراتور به کیف پول شما افزوده میشود.)</p>

            <div class="w-100 mt-2 py-2 px-4 bg-color-blue-light rounded-3 d-flex justify-content-start align-items-center">
              <p class="font-5">شناسه واریزی :</p>
              <p class="mr-3 font-5 font-bold">{{ info_bank.bank_id }}</p>
            </div>

            <div class="w-100 mt-2 py-2 px-4 bg-color-blue-light rounded-3 d-flex justify-content-start align-items-center">
              <p class="font-5">بانک ملی</p>
              <p class="mr-3 font-5 font-bold">{{ info_bank.bank_shaba }}</p>
            </div>

            <p class="mt-4 mb-2 font-4 font-bold">آپلود عکس</p>

            <div class="">
              <input @change="upload_pic" id="photo" style="display: none" type="file">

              <label class="shadow-custom rounded-4 w-100 position-relative" style="height: 16rem" for="photo">
                <img v-if="show_pic !== null" class="w-100 h-100 rounded-4" :src="show_pic">
                <img v-else class="w-100 h-100 rounded-4" src="../assets/img/add_photo.svg">
                <LoadingPic v-if="loading_pic"></LoadingPic>
              </label>
            </div>

          </div>

          <div class="d-flex justify-content-center mt-4">
            <v-btn @click="charge_wallet" class="h-100 bg-green text-white font-4 border-0 rounded-3 p-3 w-50">افزایش موجودی</v-btn>
          </div>
        </div>

        <div v-if="page === 'Transactions' " class="overflow-hidden p-3">

          <div style="height: calc(100vh - 18rem);" v-if="history.length > 0" class="overflow-y-scroll">

          <div v-for="item in history" :key="item.id" class="animate__animated animate__fadeInRight my-3 p-body py-3 bg-white rounded-3 shadow-custom">
            <div class="d-flex justify-content-between align-items-center pb-2">
              <div class="d-flex justify-content-center align-items-center">
                <img v-if="item.type === 'dec' " class="icon-size-2" src="../assets/img/mins_red.svg">
                <img v-else class="ml-2 icon-size-2" src="../assets/img/plusgreen.svg">

                <div :class="item.type === 'dec' ? 'font-color-red':'font-color-green'" class="d-flex align-items-center">
                <p class="mx-1 font-4 font-bold">{{ item.amount.toLocaleString() }}</p>
                <p class="font-5">تومان</p>
                </div>
              </div>
              <div class="d-flex justify-content-between align-items-center">
                <p class="m-0 ms-2 font-5">{{ item.date }}</p>
                <p class="m-0 font-5">{{ item.time }}</p>
              </div>
            </div>

            <div class="div_hr my-3"></div>

            <p class="font-5">{{ item.reason }}</p>
          </div>

          </div>

          <div v-else style="height: 70vh" class="d-flex w-100 animate__animated animate__fadeIn">
            <div class="d-flex flex-column align-items-center justify-content-center">
              <img src="../assets/img/payment.png" class="mb-4 w-40 icon_shadow" alt="">
              <p class="font-4 font-bold">تاریخچه کیف پول شما در حال حاضر خالی است!</p>
            </div>
          </div>
        </div>


      </div>
    </div>




        <div v-if="dialog" id="dialog" class="animate__animated animate__fadeIn dialog max_width p-body">
            <div class="bg-white rounded-4">

                <div style="height: 45px"
                     class="bg-color d-flex justify-content-center align-items-center rounded-top-4 text-center position-relative">
                    <img style="height: 10vh;left: 0" class="position-absolute bottom-0"
                         src="../assets/img/icon_record_card.svg" alt="">
                    <p class="text-white font-4">ثبت کارت</p>
                </div>

                <div class="p-3">
                    <p class="font-5 text-center mb-3">جهت تسویه و پرداخت لطفا شماره کارت خود را به اپلیکیشن اضافه کنید</p>

                    <div class="mb-3">
                        <p class="font-4 font-bold font-color mb-2">نام صاحب کارت</p>

                        <input v-model="add_card.name" :disabled="details_card" class="shadow-custom p-3 text-center font-4 rounded-4 w-100" placeholder="نام شخض حقیقی یا حقوقی" type="text">
                    </div>

                    <div class="mb-3">
                        <p class="font-4 font-bold font-color mb-2">نام بانک</p>

                        <input v-model="add_card.bankname" :disabled="details_card" class="shadow-custom p-3 text-center font-4 rounded-4 w-100" placeholder="مثلا بانک ملی" type="text">
                    </div>

                    <div class="mb-3">
                        <p class="font-4 font-bold font-color mb-2">شماره شبا مورد نظر را وارد نمایید</p>

                        <div class="position-relative">
                            <p style="left: 5%;top: 50%;transform: translate(0, -50%);" class="font-bold font-4 font-color position-absolute">IR</p>

                            <input v-model="add_card.shaba" :disabled="details_card" class="shadow-custom p-3 text-center font-4 rounded-4 w-100" placeholder="شماره شبا" maxlength="24" type="tel">
                        </div>
                    </div>

                    <div class="mb-3">
                        <p class="font-4 font-bold font-color mb-2">شماره حساب مورد نظر را وارد نمایید</p>

                        <input v-model="add_card.account" :disabled="details_card" class="shadow-custom p-3 text-center font-4 rounded-4 w-100" maxlength="18" placeholder="شماره حساب" type="tel">
                    </div>

                    <div class="mb-4">
                        <p class="font-4 font-bold font-color mb-2">شماره کارت مورد نظر را وارد نمایید</p>

                        <input v-model="add_card.card" :disabled="details_card" class="shadow-custom p-3 text-center font-4 rounded-4 w-100" maxlength="16" placeholder="شماره کارت"
                               type="tel">
                    </div>

                    <div v-if="!details_card" class="d-flex justify-content-center align-items-center">
                        <v-btn @click="add_cards"  class="w-100 h-100 bg-color rounded-4 shadow-custom text-white p-3 font-4">ارسال</v-btn>
                    </div>

                </div>
            </div>
        </div>



  </div>

</template>


<style scoped>

.list_address {
  max-height: 23vh;
  overflow-y: scroll;
}

.rotate_icon {
  transform: rotate(180deg);
  transition: .5s;
}

.min_rotate_icon {
  transform: rotate(0deg);
  transition: .5s;
}

.shadow_select {
  box-shadow: 0 -7px 15px -5px #707070;
}

.bank {
  height: 4rem;
  overflow-y: hidden;
  transition: 0.5s;
}
.div_hr {
  width: 100%;
  height: 1px;
  border: rgba(43, 48, 53, 0.47) dashed 1px;
}

</style>